import {
  IScormExportedFile,
  ScormExportFileDeliveryStatus,
} from "services/KnowfullyAdminClient";

/** A listed file, keyed for the table by its run file id. */
export type ExportedScormFileRow = IScormExportedFile & { id: string };

/**
 * useIntl's formatMessage, narrowed to what these cells use. Passed in rather than taken from useIntl
 * inside each cell so they stay presentational and can be rendered in a test without a provider.
 */
export type Translate = (descriptor: { id: string }) => string;

export const STATUS_MESSAGE_IDS: Record<ScormExportFileDeliveryStatus, string> =
  {
    [ScormExportFileDeliveryStatus.Pending]: "pendingLabel",
    [ScormExportFileDeliveryStatus.Uploaded]:
      "exportedScormFilesStatusUploaded",
    [ScormExportFileDeliveryStatus.Failed]: "exportedScormFilesStatusFailed",
  };
